<template>
  <div class="icon" :class="[name,size]"></div>
</template>

<script>
export default {
  name: 'icon',
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  &.large {
    font-size: 30px;
  }
  &.small {
    width: 20px;
    height: 20px;
    font-size: 15px;
  }
}
</style>
